// extracted by mini-css-extract-plugin
module.exports = {"totals":"Totals_totals__1vHC2"};